/**
 * Teams-related GraphQL queries
 */

// Get teams by company (for non-ROOT users)
export const GET_TEAMS_BY_COMPANY_QUERY = `
  query GetTeamsByCompany($where: teams_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [teams_order_by!] = [{ created_at: desc }]) {
    teams_aggregate(where: $where) {
      aggregate { count }
    }
    teams(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
      users {
        id
      }
      team_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
    }
  }
`;

// Get all teams for ROOT users
export const GET_ALL_TEAMS_QUERY = `
  query GetAllTeams($where: teams_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [teams_order_by!] = [{ created_at: desc }]) {
    teams_aggregate(where: $where) {
      aggregate { count }
    }
    teams(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
      users {
        id
      }
      team_tags {
        id
        tag_id
        tag {
          id
          name
          tags_color
          tags_page
        }
      }
    }
  }
`;

// Get teams by group (for GROUP_MANAGER users)
export const GET_TEAMS_BY_GROUP_QUERY = `
  query GetTeamsByGroup($groupId: Int!) {
    teams(where: { group_id: { _eq: $groupId } }, order_by: { created_at: desc }) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
      users {
        id
      }
      team_firms {
        id
      }
    }
  }
`;

// Get single team by ID
export const GET_TEAM_BY_ID_QUERY = `
  query GetTeamById($teamId: Int!) {
    teams_by_pk(id: $teamId) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
    }
  }
`;

// Get team by team ID for TEAM_MEMBER users (returns array for consistency)
export const GET_USER_TEAM_QUERY = `
  query GetUserTeam($teamId: Int!) {
    teams(where: { id: { _eq: $teamId } }) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
      users {
        id
      }
      team_firms {
        id
      }
    }
  }
`;

// Get teams by group manager ID (for GROUP_MANAGER users)
export const GET_TEAMS_BY_GROUP_MANAGER_QUERY = `
  query GetTeamsByGroupManager($managerId: Int!) {
    teams(
      where: { 
        group: { 
          group_manager_id: { _eq: $managerId } 
        } 
      }, 
      order_by: { created_at: desc }
    ) {
      id
      name
      description
      company_id
      group_id
      team_manager_id
      created_at
      updated_at
      company {
        id
        name
      }
      group {
        id
        name
        group_manager_id
      }
      user {
        id
        first_name
        last_name
        email
      }
      users {
        id
      }
      team_firms {
        id
      }
    }
  }
`;

// Get users by team (for team members)
export const GET_USERS_BY_TEAM_QUERY = `
  query GetUsersByTeam($teamId: Int!) {
    users(where: { team_id: { _eq: $teamId } }, order_by: { created_at: desc }) {
      id
      first_name
      last_name
      email
      phone_number
      role
      team_id
      created_at
      updated_at
      company {
        id
        name
      }
      title {
        id
        title_name
      }
    }
  }
`; 